import { createInjectionKey as e } from "./ghl-ui.es896.js";
const t = e("n-layout-sider");
export {
  t as layoutSiderInjectionKey
};
